import React from "react";
import { Input } from "antd";
import styles from "./CustomInputText.module.css";
import styled from "@emotion/styled";

const CustomInput = styled(Input)`
  && .ant-input-prefix {
    color: #a1a1a1;
    margin-inline-end: 0px;
  }
`;

const CustomInputText = ({ lable, onChange, value, prefix, className }) => {
  const handleChange = (e) => {
    // console.log(`switch to ${checked}`);
    onChange?.(e.target.value);
  };
  return (
    <div className={className}>
      <div>{lable}</div>
      <CustomInput
        className={styles.input}
        prefix={prefix}
        value={value}
        onChange={handleChange}
      />
    </div>
  );
};
export default CustomInputText;
